import { GeoPos } from '../geographicalpos/geographicalpos.model';
import { IUser, User } from '../users/users.model';

export interface ILoggedState {
  logged: LoggedUser;
}

export const LOGGED_STATE = {
  logged: null
};

export class LoggedUser extends User {
  token?: string;
  tokenCreation?: Date;

    constructor(obj: any) {
        const {
          id= null,
          name= '',
          auth_user= '',
          geopos= [],
          isadmin= false,
          password= '',
          token= '',
          tokenCreation= new Date()
        } = obj;

        super({id, name, auth_user, geopos, isadmin, password});

        this.token = token;
        this.tokenCreation = tokenCreation;
    }

    static from(obj): LoggedUser {
      return new LoggedUser({
        id : obj.id,
        name : obj.username,
        auth_user : obj.roles[0],
        geopos : GeoPos.fromArray(obj.geographicalPos),
        isadmin : obj.isAdmin,
        password : null,
        token: !!obj.accessToken ? obj.accessToken : null,
        tokenCreation: !!obj.accessToken ? new Date() : null
      });
    }
    static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(User.from).filter(item => item != null);
    }
}
